import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FileService {
  download(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }
}
